import React, { Fragment } from "react";
import "./index.css";

export default function ProductLocation({ address }) {
  return (
    <div className="product-location">
      {address && (
        <Fragment>
          <i className="fa fa-map-marker-alt product-location__icon" />
          <p className="product-location__text">{address.label}</p>
        </Fragment>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Package/components/ProductLocation/index.js